<template>
  <v-dialog width="1200px" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>Đổi thứ tự ưu tiên</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 py-0">
        <v-data-table
          item-key="id"
          :headers="computedHeaders"
          :loading="loading"
          :items="subGroups"
          :items-per-page="-1"
          dense
          :disable-sort="$vuetify.breakpoint.smAndDown"
          hide-default-footer
          v-bind="this.$attrs"
        >
          <template v-slot:[`footer.page-text`]="items">
            Môn thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} môn
          </template>
          <template v-slot:[`item.type`]="{ item }">
            {{ item | getType }}
          </template>
          <template v-for="subject in subjects" v-slot:[`item.subject_${subject.id}`]="{ item }">
            <div :key="subject.id">
              <v-checkbox :input-value="hasSubject(item, subject.id)" disabled></v-checkbox>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ index }">
            <v-btn icon small @click="moveItemUp(index)" :disabled="index === 0">
              <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn icon small @click="moveItemDown(index)" :disabled="index === subGroups.length - 1">
              <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider> </v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { SubjectExamGroup } from '@/plugins/api'
const originHeaders = [
  {
    text: 'STT ưu tiên',
    value: 'index',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  },
  {
    text: 'Tên tổ hợp',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },
  {
    text: 'Loại tổ hợp',
    value: 'type',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  }
]
export default {
  props: {
    state: Boolean,
    subjects: Array,
    subjectGroups: Array
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    subjectGroups: {
      handler(newVal) {
        if (newVal) {
          this.loading = false
          this.subGroups = this.subjectGroups
        }
      },
      deep: true,
      immediate: true
    },
    subjects(newSubjects) {
      this.subjectHeaders = newSubjects.map(subject => ({
        text: subject.name,
        value: `subject_${subject.id}`,
        align: 'left',
        sortable: false,
        width: '10%'
      }))
    }
  },
  computed: {
    computedHeaders() {
      const action = this.headers.findIndex(header => header.value === 'actions')
      const before = this.headers.slice(0, action)
      const after = this.headers.slice(action)
      return [...before, ...this.subjectHeaders, ...after]
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      subjectHeaders: [],
      subGroups: [],
      headers: originHeaders
    }
  },
  methods: {
    ...mapActions('subjectExamGroup', ['createSubjectGroup']),
    close() {
      this.$emit('refresh')
      this.$emit('closeDialog')
    },
    hasSubject(room, subjectId) {
      return room.subjects.some(subject => subject.id === subjectId)
    },
    async submit() {
      this.$loading.active = true
      const updatedRoom = await SubjectExamGroup.updateMany({ subjectGroups: this.subGroups })
      if (updatedRoom === 'finished') {
        this.close()
      } else {
        this.$alert.error('Lỗi thay đổi thứ tự ưu tiên')
      }
      this.$loading.active = false
    },

    moveItemUp(index) {
      if (index > 0) {
        const temp = this.subGroups[index]
        this.$set(this.subGroups, index, this.subGroups[index - 1])
        this.$set(this.subGroups, index - 1, temp)
        this.updateIndexes()
      }
    },

    moveItemDown(index) {
      if (index < this.subGroups.length - 1) {
        const temp = this.subGroups[index]
        this.$set(this.subGroups, index, this.subGroups[index + 1])
        this.$set(this.subGroups, index + 1, temp)
        this.updateIndexes()
      }
    },

    updateIndexes() {
      this.subGroups.forEach((item, newIndex) => {
        this.$set(item, 'index', newIndex + 1)
      })
    }
  },
  filters: {
    getType: item => {
      if (item.type === 'default') {
        return 'Mặc định'
      } else if (item.type === 'basic') {
        return 'Cơ bản'
      } else if (item.type === 'advanced') {
        return 'Tiên tiến'
      } else {
        return '-'
      }
    }
  }
}
</script>
